<div class="form-group">
  <label [for]="controlName">{{ nomeCampo }}</label>
  <br />
  <div class="input-group">
    <input
      #datepicker="bsDatepicker"
      bsDatepicker
      [maxlength]="modoMesAno ? 7 : 10"
      [placeholder]="placeholder || (modoMesAno ? 'MM/AAAA' : 'DD/MM/AAAA')"
      type="text"
      class="form-control round"
      [id]="controlName"
      [formControl]="control"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [bsConfig]="bsConfig"
      [ngClass]="{'is-invalid': control?.errors && isFormSubmited}"
      (focus)="campoDataSelecionado($event)"
      (onShown)="esconderCalendario()" />

    <div *ngIf="!ehVisualizar" class="input-group-append">
      <button class="btn btn-secondary round botao-calendario" type="button" (click)="mostrarCalendario()">
        <i class="fa fa-calendar"></i>
      </button>
    </div>
  </div>
  <app-validacao-form-input
    [nomeFormulario]="formGroup"
    [nomeCampo]="controlName"
    [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
</div>
